import { services } from '@fiverr-private/identification_core';

export const signUp = services.signUp;
